import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";
import shadows from "../../../../../styles/shadesPalette";
import Img from "../../../../commons/Img";

export const Wrapper = styled.div`
  width: 760px;
  height: 655px;
  background-color: white;
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 10px;
  border-radius: 8px;
  box-shadow: ${shadows.shadow3};
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 648px;
    height: 522px;
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 0px;
    padding-bottom: 30px;
  }
`;

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  @media (max-width: 1400px) {
    margin-top: -10px;
  }
`;

export const Title = styled.div`
  font-family: "OpenSansRegular";
  font-style: normal;
  color: ${colors.orange1};
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.18px;
  @media (max-width: 1400px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

export const InputTextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`;

export const Text = styled.div`
  font-family: "OpenSansRegular";
  font-style: normal;
  color: black;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.18px;
  margin-right: auto;
  @media (max-width: 1400px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Input = styled.div`
  height: 30px;
`;

export const CheckBoxContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const HelpIcon = styled(Img)`
  height: 16.67px;
  width: 16.67px;
  margin-left: 5px;
  @media (max-width: 1400px) {
    height: 12.5px;
    width: 12.5px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 5px;
`;
